import React from 'react';

import { Stack } from '@lyearn/ui';

const FlexCol: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Stack direction="col">{children}</Stack>;
};

export default FlexCol;
